export const firebaseConfig = {
  apiKey: 'AIzaSyAMESZYbOjgzEowZqRux2NUDz59Me2vrPM',
  authDomain: 'fleetchaser.firebaseapp.com',
  databaseURL: 'https://fleetchaser.firebaseio.com',
  projectId: 'fleetchaser',
  storageBucket: 'fleetchaser.appspot.com',
  messagingSenderId: '475542954499',
  appId: '1:475542954499:web:e7c0f56a51982a13436436',
};
